import { call, put, takeEvery } from 'redux-saga/effects'
import * as hanhChinhActions from '@redux/ducks/hanhChinh.Ducks'
import * as taiSanApi from '@apis/hanhChinh/taiSan.Api'
import * as danhMucTaiSanApi from '@apis/hanhChinh/danhMucTaiSan.Api'
import * as baoTriTaiSanApi from '@apis/hanhChinh/baoTriTaiSan.Api'
import * as muonTraTaiSanApi from '@apis/hanhChinh/muonTraTaiSan.Api'
import * as phongHopApi from '@apis/hanhChinh/phongHop.Api'
import * as datLichHopApi from '@apis/hanhChinh/datLichHop.Api'
import * as thanhPhanThamDuApi from '@apis/hanhChinh/thanhPhanThamDu.Api'

// Tài sản
function* fetchDanhSachTaiSan({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof taiSanApi.locTaiSan> = yield call(taiSanApi.locTaiSan, params)
    yield put(hanhChinhActions.layDanhSachTaiSanThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachTaiSanThatBai(error))
  }
}

// Danh mục tài sản
function* fetchDanhSachDanhMucTaiSan({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof danhMucTaiSanApi.locDanhMucTaiSan> = yield call(danhMucTaiSanApi.locDanhMucTaiSan, params)
    yield put(hanhChinhActions.layDanhSachDanhMucTaiSanThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachDanhMucTaiSanThatBai(error))
  }
}

// Tài liệu tài sản
function* fetchDanhSachTaiLieuTaiSan({ payload: queryStr }: { type: string; payload: any }): Generator<any, void, any> {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const assetId = params.assetId || 0
    const res: ReturnType<typeof taiSanApi.layDanhSachTaiLieuTaiSan> = yield call(taiSanApi.layDanhSachTaiLieuTaiSan, assetId)
    yield put(hanhChinhActions.layDanhSachTaiLieuTaiSanThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachTaiLieuTaiSanThatBai(error))
  }
}

// Bảo trì tài sản
function* fetchDanhSachBaoTriTaiSan() {
  try {
    const res: ReturnType<typeof baoTriTaiSanApi.layDanhSachLichBaoTriSapToi> = yield call(baoTriTaiSanApi.layDanhSachLichBaoTriSapToi)
    yield put(hanhChinhActions.layDanhSachBaoTriTaiSanThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachBaoTriTaiSanThatBai(error))
  }
}

// Mượn trả tài sản
function* fetchDanhSachMuonTraTaiSan({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof muonTraTaiSanApi.locPhieuMuonTaiSan> = yield call(muonTraTaiSanApi.locPhieuMuonTaiSan, params)
    yield put(hanhChinhActions.layDanhSachMuonTraTaiSanThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachMuonTraTaiSanThatBai(error))
  }
}

// Phòng họp
function* fetchDanhSachPhongHop({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof phongHopApi.locDanhSachPhongHop> = yield call(phongHopApi.locDanhSachPhongHop, params)
    yield put(hanhChinhActions.layDanhSachPhongHopThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachPhongHopThatBai(error))
  }
}

// Đặt lịch họp
function* fetchDanhSachDatLichHop({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof datLichHopApi.locDanhSachDatLichHop> = yield call(datLichHopApi.locDanhSachDatLichHop, params)
    yield put(hanhChinhActions.layDanhSachDatLichHopThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachDatLichHopThatBai(error))
  }
}

// Thành phần tham dự
function* fetchDanhSachThanhPhanThamDu({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    // API requires meetingBookingId
    const meetingBookingId = params.meetingBookingId || 0
    const res: ReturnType<typeof thanhPhanThamDuApi.layDanhSachNguoiThamDu> = yield call(thanhPhanThamDuApi.layDanhSachNguoiThamDu, meetingBookingId)
    yield put(hanhChinhActions.layDanhSachThanhPhanThamDuThanhCong(res))
  } catch (error) {
    yield put(hanhChinhActions.layDanhSachThanhPhanThamDuThatBai(error))
  }
}

export default function* watchHanhChinh() {
  yield takeEvery(hanhChinhActions.layDanhSachTaiSan.toString(), fetchDanhSachTaiSan)
  yield takeEvery(hanhChinhActions.layDanhSachDanhMucTaiSan.toString(), fetchDanhSachDanhMucTaiSan)
  yield takeEvery(hanhChinhActions.layDanhSachTaiLieuTaiSan.toString(), fetchDanhSachTaiLieuTaiSan)
  yield takeEvery(hanhChinhActions.layDanhSachBaoTriTaiSan.toString(), fetchDanhSachBaoTriTaiSan)
  yield takeEvery(hanhChinhActions.layDanhSachMuonTraTaiSan.toString(), fetchDanhSachMuonTraTaiSan)
  yield takeEvery(hanhChinhActions.layDanhSachPhongHop.toString(), fetchDanhSachPhongHop)
  yield takeEvery(hanhChinhActions.layDanhSachDatLichHop.toString(), fetchDanhSachDatLichHop)
  yield takeEvery(hanhChinhActions.layDanhSachThanhPhanThamDu.toString(), fetchDanhSachThanhPhanThamDu)
}

